import { supabase } from '@/lib/supabaseClient';
import type { SiteRating, SiteRatingInput } from '@/types/siteRatings';

export async function fetchSiteRatingBySiteId(
  siteId: string
): Promise<SiteRating | null> {
  try {
    const { data, error } = await supabase
      .from('site_ratings')
      .select('*')
      .eq('site_id', siteId)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error('評価の取得に失敗しました:', error);
      throw new Error('評価の取得に失敗しました');
    }

    return data as SiteRating;
  } catch (err) {
    console.error('評価の取得エラー:', err);
    return null;
  }
}

export async function upsertSiteRating(
  input: SiteRatingInput
): Promise<SiteRating> {
  try {
    const { data, error } = await supabase
      .from('site_ratings')
      .upsert(
        {
          site_id: input.site_id,
          rating_clarity: input.rating_clarity,
          rating_self_study: input.rating_self_study,
          rating_printability: input.rating_printability,
          rating_design: input.rating_design,
          rating_uniqueness: input.rating_uniqueness,
          usage_ibasho: input.usage_ibasho,
          usage_home: input.usage_home,
          usage_self: input.usage_self,
          good_points: input.good_points,
          caution_points: input.caution_points || null,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'site_id' }
      )
      .select()
      .single();

    if (error) {
      console.error('評価の保存に失敗しました:', error);
      throw new Error('評価の保存に失敗しました');
    }

    return data as SiteRating;
  } catch (err) {
    console.error('評価の保存エラー:', err);
    throw err;
  }
}
